"use client";

import * as React from "react";
import { Quote } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const testimonials = [{
  author: "Shaun",
  quote: "\"I had a very complex situation with 11 home loans worth over $5 million, and Sash from SLA Finance made what seemed impossible a reality. From the beginning, Sash was proactive, professional, and kept in regular contact.\"",
  position: "Managing Director",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637844/img/creator_avatar_a.png"
}, {
  author: "Jason",
  quote: "I had a fantastic experience working with Sash. He was extremely detailed throughout the whole process and made everything run smoothly. Compared to other brokers I’ve dealt with, he is far more knowledgeable and explained things clearly so I always felt confident with my decisions. Most importantly, he got my home loan approved quickly and without any hassle.\xA0",
  position: "Homeowner",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637844/img/creator_avatar_b.png"
}];
export default function CreatorTestimonials() {
  return <section data-section-id="224046" id="success-stories" className="bg-background text-foreground py-24 relative overflow-hidden flex items-center justify-center min-h-[80vh]">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-chart-2/5 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-primary/5 rounded-full blur-[100px] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-16 relative z-10">
        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full max-w-5xl mx-auto">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <div className="p-2 md:p-6">
                  <Card className="bg-card border-border/50 backdrop-blur-sm shadow-xl overflow-hidden relative group">
                    {}
                    <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-chart-2 via-primary to-chart-2 opacity-30 group-hover:opacity-100 transition-opacity duration-500" />
                    
                    <CardContent className="flex flex-col items-center text-center p-8 md:p-16 gap-8">
                      <div className="relative">
                        <div className="absolute -inset-4 bg-chart-2/10 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                        
                        <div className="absolute -bottom-4 -right-4 bg-background rounded-full p-2 border border-border shadow-md z-20 text-chart-2">
                          <Quote size={24} className="fill-current" />
                        </div>
                      </div>

                      <blockquote className="text-xl md:text-2xl italic font-medium font-default leading-relaxed text-foreground max-w-3xl">
                        "{testimonial.quote}"
                      </blockquote>

                      <div className="flex flex-col items-center gap-2 mt-4">
                        <span className="text-primary font-default font-bold text-lg md:text-xl tracking-tight">
                          {testimonial.author}
                        </span>
                        
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="hidden md:block">
            <CarouselPrevious className="left-0 xl:-left-12 bg-background/80 border-border hover:bg-primary hover:border-primary hover:text-primary-foreground hover:shadow-lg transition-all duration-300 size-12 backdrop-blur-sm" />
            <CarouselNext className="right-0 xl:-right-12 bg-background/80 border-border hover:bg-primary hover:border-primary hover:text-primary-foreground hover:shadow-lg transition-all duration-300 size-12 backdrop-blur-sm" />
          </div>
          
          {}
          <div className="flex justify-center gap-4 mt-8 md:hidden">
            <CarouselPrevious className="static translate-y-0 translate-x-0 bg-background/80 border-border hover:bg-primary hover:border-primary hover:text-primary-foreground transition-all duration-300 size-12 backdrop-blur-sm" />
            <CarouselNext className="static translate-y-0 translate-x-0 bg-background/80 border-border hover:bg-primary hover:border-primary hover:text-primary-foreground transition-all duration-300 size-12 backdrop-blur-sm" />
          </div>
        </Carousel>
      </div>
    </section>;
}